import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './components/no-auth/login/login.component';
import {UpdatePasswordComponent} from "./components/no-auth/update-password/update-password.component";
import {ResetPasswordTokenComponent} from "./components/no-auth/reset-password-token/reset-password-token.component";
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/pages/pages.router.module').then(mod => mod.PagesRouterModule)
  },
  { path: 'login', component: LoginComponent},
  { path: 'password-reset/:token', component: ResetPasswordTokenComponent},
  { path: 'update-password', component: UpdatePasswordComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
